/* eslint-disable camelcase */
import { get } from 'lodash'
import moment from 'moment'
import { GoogleAnalytics } from './google_analytics'

class ItemListViewV2 extends GoogleAnalytics {
  constructor (amountPerPax = false, ...args) {
    super(...args)
    this.amountPerPax = amountPerPax
  }

  getItemListViewData () {
    return {
      ecommerce: {
        item_list_id: this.createItemListId(),
        item_list_name: 'FLIGHT',
        currency: this.currency,
        items: this.getItems(),
        ...this.searchFlightData
      }
    }
  }

  process () {
    this.data = this.getItemListViewData()
    return this.pushEvent()
  }

  getItems () {
    try {
      let items = new ItemViewV2(false, false, this.amountPerPax, null, this.itemData).getItemList()
      return items
    } catch (error) {
      console.error('error create items list. ' + error)
      return []
    }
  }
}

class ItemViewV2 extends GoogleAnalytics {
  constructor (isReturnFlight, isRoundTrip, amountPerPax = false, ...args) {
    super(...args)
    this.isReturnFlight = isReturnFlight
    this.isRoundTrip = isRoundTrip
    this.amountPerPax = amountPerPax
  }

  process () {
    this.data = {
      ecommerce: this._getItems()
    }
    return this.pushEvent()
  }

  _getItems () {
    const flight = this.itemData
    const fare = flight.fare.fare_information
    const itemId = this.createItemId(flight.flight_detail[0])
    const itemName = this.createItemName(flight.flight_detail[0])
    const typeOfFlight = this.getTypeOfFlight(flight)
    const flightDuration = this.getFlightDuration(flight)
    const ffam = flight.fare.code
    const rbd = this.getRbd(fare.rbd)
    const departureTime = this.formatTime(flight.departure.time)
    const value = ((this.isRoundTrip && this.isReturnFlight) || !this.isRoundTrip) ? this.getValue(fare) : null
    const adults = this.itemData.adults
    const childs = this.itemData.minors
    const infants = this.itemData.infants

    const itemObject = this.getItemView(
      false,
      value,
      ffam,
      rbd,
      typeOfFlight,
      flightDuration,
      departureTime,
      this.resolvePrice(fare),
      adults,
      childs,
      infants,
      itemId,
      itemName
    )

    return itemObject
  }

  resolvePrice (price) {
    return this.amountPerPax ? price.total_per_pax_adt : price.total
  }

  getItemList() {
    const itemList = new Set()
    const { flights, fares, fares_information } = this.itemData
    const nextFareKeys = []
  
    const processFare = (flight, fareKey, upsellingKey, itemList) => {
      const fare = fares[fareKey]
      const ffam = fares_information[upsellingKey].code
      const rbd = this.getRbd(fare.rbd[flight.trip_segment])
      const typeOfFlight = this.getTypeOfFlight(flight)
      const flightDuration = this.getFlightDuration(flight)
      const flightTime = this.formatTime(flight.flight_detail[0].departure.time)
      const price = this.resolvePrice(fare.trip_segment_prices[flight.trip_segment])
      const { adults, minors: childs, infants } = this.itemData
      const itemId = this.createItemId(flight.flight_detail[0])
      const itemName = this.createItemName(flight.flight_detail[0])
  
      const item = this.getItemView(true, 0, ffam, rbd, typeOfFlight, flightDuration, flightTime, price, adults, childs, infants, itemId, itemName)
      itemList.add(JSON.stringify(item))
    }
  
    for (const flightKey in flights) {
      const flight = flights[flightKey]
  
      if (flight.trip_segment === 1) {
        for (const upsellingKey in flight.upselling) {
          const upselling = flight.upselling[upsellingKey]
          if (upselling.next_flight_fares) {
            const _nextFareKeys = Object.values(upselling.next_flight_fares).map(e => e.next_fare_keys)
            for (const items of _nextFareKeys) {
              for (const item in items){
                nextFareKeys.push([item, items[item]])
              }
            }
          }

          processFare(flight, upselling.fare_key, upsellingKey, itemList)
        }
      } else {
        for (const [upsellingKey, { fare_key: fareKey }] of nextFareKeys) {
          processFare(flight, fareKey, upsellingKey, itemList)
        }
      }
    }
  
    return Array.from(itemList).map(e => JSON.parse(e))
  }

  createItemId (flightDetail) {
    const { carrier_code, flight_number, departure, arrival } = flightDetail
    const date = moment(departure.date).format('DD-MM-YYYY')
    return `${carrier_code}${flight_number}_${departure.airport_reference_id}/${arrival.airport_reference_id}_${date}`
  }

  createItemName(flightDetail) {
    const { departure, arrival } = flightDetail

    return `${departure.airport_reference_id}/${arrival.airport_reference_id}`
  }

  getFlightDuration (flight) {
    // item_category 4
    const duration = moment.duration(flight.travel_time, 'minutes')
    return moment.utc(duration.asMilliseconds()).format('HH:mm[hs]')
  }

  getTypeOfFlight (flight) {
    // item_category3
    let type = ''
    const connections = get(flight, 'connections') > 0 ? get(flight, 'connections') + ' CONNECTIONS' : ''
    const stops = get(flight, 'stops') > 0 ? get(flight, 'stops') + ' STOPS' : ''
    if (stops === '' && connections === '') {
      return 'DIRECT'
    }
    type = connections.concat('' + stops)
    return type
  }
}

export { ItemListViewV2, ItemViewV2 }
